import React, { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';

const WHATSAPP = "233544205844";

const WhatsAppWidget = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className="fixed bottom-6 right-6 z-50" data-testid="whatsapp-widget">
      {/* Chat Popup */}
      {open && (
        <div className="mb-4 w-80 bg-white rounded-2xl shadow-2xl border border-gray-200 overflow-hidden animate-in slide-in-from-bottom-4 duration-300">
          <div className="bg-green-600 px-5 py-4 flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
                <MessageCircle size={20} className="text-white" />
              </div>
              <div>
                <p className="text-white font-semibold text-sm">RunTheRays Team</p>
                <p className="text-green-100 text-xs flex items-center gap-1">
                  <span className="w-2 h-2 bg-green-300 rounded-full inline-block animate-pulse"></span>
                  Online — replies instantly
                </p>
              </div>
            </div>
            <button onClick={() => setOpen(false)} className="text-white/80 hover:text-white" data-testid="whatsapp-widget-close">
              <X size={20} />
            </button>
          </div>
          <div className="p-5">
            <div className="bg-gray-100 rounded-xl rounded-tl-sm p-3 mb-4">
              <p className="text-sm text-gray-700">Hi there! How can we help you today? Send us a message and we'll reply right away.</p>
            </div>
            <a
              href={`https://wa.me/${WHATSAPP}?text=Hi! I'd like to inquire about your trading services.`}
              target="_blank"
              rel="noopener noreferrer"
              className="w-full flex items-center justify-center gap-2 bg-green-600 hover:bg-green-700 text-white py-3 rounded-xl font-semibold text-sm transition-colors"
              data-testid="whatsapp-widget-chat-btn"
            >
              <MessageCircle size={18} /> Start Chat on WhatsApp
            </a>
          </div>
        </div>
      )}

      {/* Floating Button */}
      <button
        onClick={() => setOpen(o => !o)}
        className="w-16 h-16 bg-green-600 hover:bg-green-700 text-white rounded-full shadow-lg hover:shadow-xl flex items-center justify-center transition-all duration-300 hover:scale-110 relative"
        data-testid="whatsapp-widget-btn"
      >
        {open ? <X size={26} /> : <MessageCircle size={26} />}
        {!open && (
          <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full border-2 border-white animate-pulse"></span>
        )}
      </button>
    </div>
  );
};

export default WhatsAppWidget;
